export const ENGINEERING_SYSTEMS_PATH = '/uslugi/gotovye-resheniya-pod-klyuch/inzhenernye-sistemy/';

export const ENGINEERING_SYSTEMS_LANDING_NAME = 'engineering-systems';

export const ENGINEERING_SYSTEMS_CDN_PATH =
  'https://cdn.lemanapro.ru/lmru/image/upload/f_auto,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/engineering-systems';

export const ENGINEERING_SYSTEMS_STORAGE_PATH =
  'https://storage.yandexcloud.net/lemanapro-ru-landings-docs/inzhenernye-sistemy/';

export const DEFAULT_CONSULTATION_SECTION_TITLE =
  'Получите подробную консультацию и\u00A0узнайте стоимость\u00A0работ';

export const DEFAULT_CONSULTATION_SUB_CHANNEL = 'LANDING';
